// src/components/dialogs/DetailDialog.jsx

import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    AppBar
} from "@mui/material";

const DetailDialog = ({
    open,
    title,
    onClose,
    okText = "OK",
    maxWidth = "md",
    custActions,
    children,
}) => (
    <>

        <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth sx={{ pt: 5 }}>
            <div>{custActions}</div>
            {title && <DialogTitle>{title}</DialogTitle>}
            <DialogContent dividers>
                {children}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">
                    {okText}
                </Button>
            </DialogActions>
        </Dialog>
    </>

);

export default DetailDialog;
